import React, { FC, useEffect, useState } from 'react';
import {
  CampaignOnboardingImageDirection,
  CampaignOnboardingModalProps,
} from 'models/campaign-mkt';
import { onboardingSteps, preloadOnboardingImages } from 'utils/campanha-utils';
import * as S from './style';

const CampaignOnboardingModal: FC<CampaignOnboardingModalProps> = ({
  show,
  onClose,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [imageDirection, setImageDirection] = useState<
    CampaignOnboardingImageDirection
  >('initial');
  const step = onboardingSteps[currentStep];
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === onboardingSteps.length - 1;

  useEffect(() => {
    preloadOnboardingImages();
  }, []);

  const handlePrevious = () => {
    if (!isFirstStep) {
      setImageDirection('previous');
      setCurrentStep(currentStep - 1);
    }
  };

  const handleNext = () => {
    if (!isLastStep) {
      setImageDirection('next');
      setCurrentStep(currentStep + 1);
    }
  };

  const handleDotClick = (stepIndex: number) => {
    if (stepIndex === currentStep) return;

    setImageDirection(stepIndex > currentStep ? 'next' : 'previous');
    setCurrentStep(stepIndex);
  };

  return (
    <S.ModalStyled
      backdrop
      centered
      dialogClassName="campaign-onboarding-modal"
      keyboard={false}
      onHide={() => undefined}
      show={show}
    >
      <S.Content>
        <S.TextColumn>
          <S.TextContent $direction={imageDirection} key={step.title}>
            <S.Title>{step.title}</S.Title>
            <S.Text>{step.text}</S.Text>
          </S.TextContent>

          <S.Navigation>
            <S.ArrowButton
              aria-label="Voltar etapa"
              disabled={isFirstStep}
              onClick={handlePrevious}
              type="button"
            >
              <S.ArrowIcon $direction="left" />
            </S.ArrowButton>
            <S.ArrowButton
              aria-label="Avançar etapa"
              disabled={isLastStep}
              onClick={handleNext}
              type="button"
            >
              <S.ArrowIcon $direction="right" />
            </S.ArrowButton>
          </S.Navigation>

          <S.ActionButton onClick={onClose} type="button">
            Começar a usar
          </S.ActionButton>
        </S.TextColumn>

        <S.ImageColumn>
          <S.CloseButton
            aria-label="Fechar modal"
            onClick={onClose}
            type="button"
          >
            <S.CloseIcon />
          </S.CloseButton>
          <S.Image
            $direction={imageDirection}
            alt=""
            key={step.title}
            src={step.image}
          />
          <S.Dots>
            {onboardingSteps.map((item, index) => (
              <S.Dot
                $active={index === currentStep}
                aria-label={`Ir para etapa ${index + 1}`}
                disabled={index === currentStep}
                key={item.title}
                onClick={() => handleDotClick(index)}
                type="button"
              />
            ))}
          </S.Dots>
        </S.ImageColumn>
      </S.Content>
    </S.ModalStyled>
  );
};

export default CampaignOnboardingModal;
